import { Box, MenuItem, Typography } from '@mui/material';
import axios from 'axios';
import Iconify from '../Iconify';
import { openPublicQrPage } from '../../utils/publicQrPage';

/**
 * Header action next to QRcode — opens the same public page the QR encodes,
 * on this browser origin (local / DEV / PROD).
 */
const OpenPublicPageAction = ({ endpoint, entityId, asMenuItem = false }) => {
  const handleOpen = async () => {
    if (!entityId) {
      return;
    }
    const { data, status } = await axios.get(`${endpoint}/${entityId}/public-path`);
    if ((status === 200 || status === 201) && data?.path) {
      openPublicQrPage(data.path);
    }
  };

  const label = (
    <>
      <Iconify className="MachineDetailsHeader_copy_icon" icon="mdi:open-in-new" />
      <Typography className="MachineDetailsHeader_copy_title">Page publique</Typography>
    </>
  );

  if (asMenuItem) {
    return (
      <MenuItem className="MachineDetailsHeader_menuItem" onClick={handleOpen}>
        {label}
      </MenuItem>
    );
  }

  return (
    <Box className="MachineDetailsHeader_action_box" onClick={handleOpen}>
      {label}
    </Box>
  );
};

export default OpenPublicPageAction;
